export default __webpack_public_path__ + "static/media/KEI-logo.3233af90.png";